<template>
  <PaOverlayModal
   :isOpen="isOpenEditorModal"
   :appendClass="['pa-park-note-editor-modal']"
   :position="{top: 0}"
   :contentTransitionName="'pa-simple-fade'"
   :isFreez="true"

   @afterEnterContent="handleAfterEnterContent"
   @afteredAfterEnterContent="handleAfterdAfterEnterContent"
   @beforeEnterContent="handleBeforeEnterContent"
   @closeOverlayModal="handleCloseOverlay"
  >
  <div class="pa-contents pa-park-note-editor-modal-contents">
    <div class="pa-park-note-editor-box" ref="editorBox">
      <div class="editor-field" ref="editorField">
        <PAParkNoteEditorQuillNew
         :editorFieldHeight="editorFieldHeight"
         :enableDraftFunction="isEnableDraftFunction"
         :draftParkNote="draftParkNoteFromParkId"
         :defaultTitle="defaultTitle"
         :defaultDeltaString="defaultBodyDeltaString"
         :shouldShowInkCounter="shouldShowInkCounter"
         :textCountingStartLimit="textCountingStartLimit"

         @onChangeTitle="handleOnTitleChange"
         @onEditorChange="handleOnEditorChange"
         @onClickDeleteDraftData="handleClickDeleteDraftData"
        />
      </div>
      <div class="button-field" ref="buttonField">
        <button class="button pa-button-submit"
        :class="additionalSubmitButtonClass"
        :disabled="isDisableSubmitButton"
        @click.prevent="handleClickSubmit"
        >{{submitButtonText}}</button>
        
        <div class="cancel-button-wrapper">
          <button
          class="button pa-button-cancel"
          :class="additionalCancelButtonClass"
          :disabled="isDisableCancelButton"
          @click="handleClickCancel"
          >{{cancelButtonText}}</button>
        </div>
      </div>
    </div>
  </div>
  </PaOverlayModal>
</template>

<script>
import PaOverlayModal           from '@/components/Parts/PAOverlayModal/PAOverlayModal.vue'
import PAParkNoteEditorQuillNew from '@/components/Parts/PAParkNoteEditorQuillNew/PAParkNoteEditorQuillNew.vue'

import PAParkNoteModalControlMixin                from '@/components/Parts/PAParkNoteEditorNew/mixins/PAParkNoteModalControlMixin.js'
import PAParkNoteEditorButtonsMixin               from '@/components/Parts/PAParkNoteEditorNew/mixins/PAParkNoteEditorButtonsMixin.js'
import PAParkNoteEditorSubmitControlMixin         from '@/components/Parts/PAParkNoteEditorNew/mixins/PAParkNoteEditorSubmitControlMixin.js'
import PAParkNoteEditorEditBehaviourControlMixin  from '@/components/Parts/PAParkNoteEditorNew/mixins/PAParkNoteEditorEditBehaviourControlMixin.js'
import PAParkNoteEditorDraftControlMixin          from '@/components/Parts/PAParkNoteEditorNew/mixins/PAParkNoteEditorDraftControlMixin.js'
import TextSendWarningMixins                      from '@/mixins/TextSendWarningMixins.js'

export default {
  components : {
    PaOverlayModal,
    PAParkNoteEditorQuillNew
  },

  mixins : [
    PAParkNoteModalControlMixin,
    PAParkNoteEditorButtonsMixin,
    PAParkNoteEditorSubmitControlMixin,
    PAParkNoteEditorEditBehaviourControlMixin,
    PAParkNoteEditorDraftControlMixin,
    TextSendWarningMixins
  ],

  data(){
    return {
      isOpenEditorModal       : false,
      editorBehaviour         : 'new', // [new | edit]

      titleData               : '',
      editorData              : null,

      titleLimitationLength   : 16,
      shouldShowInkCounter    : false,
      textCountingStartLimit  : null,
    };
  },

  computed : {
    parkId(){
      return this.$route.params.parkId;
    },
    
    isOpenParkBoardEditor(){
      return this.$store.state.createButton.isOpenParkBoardEditor;
    },

    isOpenEditEditorModal(){
      return this.$store.state.parkNote.isOpenEditEditorModal;
    },
  },

  watch : {
    titleData(value){
      if(value.trim().length > this.titleLimitationLength){
        this.showTitleTextOveredAlert();
      }
    },
    
    //, parkNoteId : {
    //   handler(value){
    //     console.log(value);
    //   },
    //   immediate: true
    // }

    isOpenParkBoardEditor(){
      this.checkIsOpenModal();
    },

    isOpenEditEditorModal(){
      this.checkIsOpenModal();
    }
  },

  methods : {
    checkIsOpenModal(){
      if(this.isOpenParkBoardEditor === true || this.isOpenEditEditorModal === true){
        this.isOpenEditorModal = true;
      }

      if(this.isOpenParkBoardEditor === false && this.isOpenEditEditorModal === false){
        this.isOpenEditorModal = false;
      }

      if(this.isOpenParkBoardEditor === true){
        this.editorBehaviour = 'new';
      }else if(this.isOpenEditEditorModal === true){
        this.editorBehaviour = 'edit';
      }

      // console.log(this.isOpenParkBoardEditor);
      // console.log(this.isOpenEditEditorModal);
      // console.log(this.editorBehaviour);
    },

    handleOnTitleChange(data){
      this.titleData = data;
    },

    handleOnEditorChange(data){
      this.editorData = data;
    },

    showTitleTextOveredAlert(){
      const limitationFullWidthed = this.$options.filters.mutateFullWidth(this.titleLimitationLength);

      this.$store.dispatch({
        type        : 'flashMessage/updateFlashMessage',
        hasMessage  : true,
        message     : '&nbsp;タイトルは'+limitationFullWidthed+'文字以内でご入力ください。',
        status      : 'error',
        hasControl  : true,
        autoClose   : 1000
      }, {root:true});
    },

    showShouldInputTitleAndBodyAlert(){
        this.$store.dispatch({
          type        : 'flashMessage/updateFlashMessage',
          hasMessage  : true,
          message     : '&nbsp;タイトル、本文は必ず入力してください。',
          status      : 'error',
          hasControl  : true,
          autoClose   : 3000
        }, {root:true});
    }
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-contents.pa-park-note-editor-modal-contents{
  position: fixed;
  top:0;
  left:0;
  z-index: 1000;

  width: 100%;
  height: 100%;

  .pa-park-note-editor-box{
    box-sizing: border-box;
    position:absolute;
    top:1rem;
    left:0;
    
    width:100%;
    height:calc(100% - (2rem + env(safe-area-inset-top) + env(safe-area-inset-bottom)));
    
    overflow: hidden;
    display:flex;
    flex-direction: column;

    // background-color:cadetblue; // for debug

    .editor-field{
      overflow: hidden; /* for quill loader overflow. */
      // background:gray;
    }

    .button-field{
      box-sizing: border-box;
      flex-grow: 0;
      display:block;
      width: 98%;
      margin:0 auto;
      padding:6px 0 0;

      @include from($desktop) {
        width:632px;
        padding:8px 0 0;
      }

      .cancel-button-wrapper{
        text-align: center;
      }

      button.button{
        cursor: pointer;
        user-select: none;
        height:inherit;
        border-radius:0;
        padding:0;

        &.pa-button{
          &-submit{
            display: block;
            margin:0 auto;
            text-align: center;
            border-radius: 4px;
            width:98%;
            font-size:1.2rem;
            border:2.3px solid #723E14;
            background-color: #874D26;
            color:#E8DFD9;

            &:disabled{
              color:#8E8376;
            }
          }

          &-cancel{
            cursor: pointer;
            background-color: inherit;
            border:0;
            margin:0;
            padding:0 .1rem;
            padding-left:.6rem;
            letter-spacing: .5rem;
            border-bottom:2px solid #BBA891;
            color:#BBA891;
            font-size: 1rem;
            line-height: 1.9;
            
            &:disabled{
              border-bottom:2px solid #8E8376;
              color:#8E8376;
            }
          }
        }
      }
    }
  }
}
</style>